<template>
  <div class="cm">
    <!-- 头部：标题 / 战利品 -->
    <div class="cm-head">
      <div class="cm-title">🧸 粉裙娃娃机</div>
      <div class="cm-caught">
        <span
            v-for="(doll, i) in caught"
            :key="i"
            class="cm-caught-item"
            :title="'已抓到 ' + doll.emoji">{{ doll.emoji }}</span>
        <span v-if="!caught.length" class="cm-caught-empty">还没有抓到娃娃～</span>
      </div>
    </div>

    <!-- 机台 -->
    <div class="cm-stage">
      <!-- 轨道 + 爪子 -->
      <div class="cm-track">
        <div class="cm-claw" :style="{ left: clawX + 'px' }">
          <div class="cm-claw-arm" :style="{ height: clawY + 'px' }"></div>
          <div class="cm-claw-head" :class="{ grabbing: state === 'grabbing' || !!held }">
            <span class="cm-pincer cm-pincer-l"></span>
            <span class="cm-pincer cm-pincer-r"></span>
          </div>
          <span v-if="held" class="cm-held" :style="{ top: clawY + 30 + 'px' }">{{ held.emoji }}</span>
        </div>
      </div>

      <!-- 娃娃区 -->
      <div class="cm-zone">
        <span
            v-for="doll in dolls"
            :key="doll.id"
            class="cm-doll"
            :style="{ left: doll.x + 'px', top: doll.y + 'px' }">{{ doll.emoji }}</span>
      </div>

      <!-- 出口 -->
      <div class="cm-chute">
        <span class="cm-chute-label">🎁 收获口</span>
      </div>

      <!-- 状态提示 -->
      <div class="cm-state-tip">{{ stateText }}</div>
    </div>

    <!-- 控制区 -->
    <div class="cm-controls">
      <button
          type="button"
          class="cm-btn cm-btn-move"
          :disabled="state !== 'idle'"
          @mousedown.prevent="startMove(-1)"
          @mouseup.prevent="stopMove()"
          @mouseleave="stopMove()">◀</button>
      <button
          type="button"
          class="cm-btn cm-btn-drop"
          :disabled="state !== 'idle'"
          @click="drop">⬇ 下爪</button>
      <button
          type="button"
          class="cm-btn cm-btn-move"
          :disabled="state !== 'idle'"
          @mousedown.prevent="startMove(1)"
          @mouseup.prevent="stopMove()"
          @mouseleave="stopMove()">▶</button>
    </div>
    <p class="cm-tip">按住 ◀ ▶ 移动爪子（键盘 ← → 移动，空格下爪），抓到的娃娃会存进战利品～</p>
  </div>
</template>

<script>
/* =====================================================
 * 粉裙娃娃机（夹娃娃）
 * 状态机：idle 待机移动 → dropping 下爪 → grabbing 抓取
 *         → rising 上升 → 释放入账 → idle
 * ===================================================== */
const DOLLS_EMOJI = ['🧸', '🐰', '🍓', '🎀', '🌸', '🐻', '🧁', '⭐', '🍬', '💗']
const ZONE_W = 340      // 娃娃区宽度
const CLAW_W = 30       // 爪子宽度
const DROP_Y = 128      // 爪子下落深度（臂长 px）
const COLS = 6
const ROWS = 2

export default {
  name: 'ClawMachine',
  data () {
    return {
      dolls: [],
      caught: [],
      clawX: 120,
      clawY: 0,
      state: 'idle',     // idle | dropping | grabbing | rising
      held: null,
      moveDir: 0,
      moveTimer: null,
      animTimer: null,
      stateText: '移动爪子，按下爪开始～'
    }
  },
  created () {
    this.placeDolls()
  },
  mounted () {
    window.addEventListener('keydown', this.onKey)
    window.addEventListener('keyup', this.onKeyUp)
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.onKey)
    window.removeEventListener('keyup', this.onKeyUp)
    this.clearTimers()
  },
  computed: {
    clawCenter () {
      return this.clawX + CLAW_W / 2
    }
  },
  methods: {
    /* ---------- 摆放娃娃 ---------- */
    placeDolls () {
      const list = []
      const used = {}
      const total = COLS * ROWS
      // 随机选 8~10 个格子放娃娃
      const count = 8 + Math.floor(Math.random() * 3)
      let n = 0
      let guard = 0
      while (n < count && guard < 200) {
        guard++
        const col = Math.floor(Math.random() * COLS)
        const row = Math.floor(Math.random() * ROWS)
        const key = col + '-' + row
        if (used[key]) continue
        used[key] = true
        list.push({
          id: 'd' + n + '_' + Math.floor(Math.random() * 10000),
          emoji: DOLLS_EMOJI[Math.floor(Math.random() * DOLLS_EMOJI.length)],
          x: 24 + col * ((ZONE_W - 48) / (COLS - 1)),
          y: 14 + row * 52
        })
        n++
      }
      this.dolls = list
      this.caught = []
      this.held = null
      this.clawX = ZONE_W / 2 - CLAW_W / 2
      this.clawY = 0
      this.state = 'idle'
      this.stateText = '移动爪子，按下爪开始～'
    },

    /* ---------- 键盘 ---------- */
    onKey (e) {
      if (e.key === 'ArrowLeft' || e.key === 'a' || e.key === 'A') {
        e.preventDefault()
        this.startMove(-1)
      } else if (e.key === 'ArrowRight' || e.key === 'd' || e.key === 'D') {
        e.preventDefault()
        this.startMove(1)
      } else if (e.key === ' ') {
        e.preventDefault()
        this.drop()
      }
    },
    onKeyUp (e) {
      if (['ArrowLeft', 'ArrowRight', 'a', 'A', 'd', 'D'].indexOf(e.key) !== -1) {
        this.stopMove()
      }
    },

    /* ---------- 移动爪子 ---------- */
    startMove (dir) {
      if (this.state !== 'idle') return
      this.moveDir = dir
      if (this.moveTimer) return
      this.moveTimer = setInterval(() => {
        const step = 3
        let nx = this.clawX + this.moveDir * step
        nx = Math.max(6, Math.min(ZONE_W - CLAW_W - 6, nx))
        this.clawX = nx
      }, 24)
    },
    stopMove () {
      this.moveDir = 0
      if (this.moveTimer) {
        clearInterval(this.moveTimer)
        this.moveTimer = null
      }
    },

    /* ---------- 下爪 / 上升状态机 ---------- */
    drop () {
      if (this.state !== 'idle') return
      this.stopMove()
      this.state = 'dropping'
      this.stateText = '爪子下落中…'
      this.clawY = 0
      this.animTimer = setInterval(() => {
        this.clawY += 4
        if (this.clawY >= DROP_Y) {
          this.clawY = DROP_Y
          clearInterval(this.animTimer)
          this.animTimer = null
          this.grabCheck()
          this.state = 'grabbing'
          this.stateText = this.held ? '抓住啦！' : '哎呀，抓空了…'
          setTimeout(() => this.rise(), 420)
        }
      }, 30)
    },
    grabCheck () {
      let nearest = null
      let minDist = 999
      this.dolls.forEach(d => {
        const dCenter = d.x + 16
        const dist = Math.abs(dCenter - this.clawCenter)
        if (dist < minDist) { minDist = dist; nearest = d }
      })
      // 距离足够近且有 85% 抓取成功率
      if (nearest && minDist < 34 && Math.random() < 0.85) {
        this.held = nearest
      }
    },
    rise () {
      this.state = 'rising'
      this.stateText = this.held ? '娃娃上来了！' : '空手而归…'
      this.animTimer = setInterval(() => {
        this.clawY -= 4
        if (this.clawY <= 0) {
          this.clawY = 0
          clearInterval(this.animTimer)
          this.animTimer = null
          this.release()
        }
      }, 30)
    },
    release () {
      if (this.held) {
        this.caught.push({ emoji: this.held.emoji })
        this.dolls = this.dolls.filter(d => d.id !== this.held.id)
        this.held = null
        this.stateText = '🎉 收获 +1 ！'
      } else {
        this.stateText = '再试一次吧～'
      }
      this.state = 'idle'
      if (!this.dolls.length) {
        this.stateText = '娃娃都被抓完啦，重新摆放！'
        setTimeout(() => this.placeDolls(), 700)
      }
    },

    /* ---------- 工具 ---------- */
    clearTimers () {
      if (this.moveTimer) { clearInterval(this.moveTimer); this.moveTimer = null }
      if (this.animTimer) { clearInterval(this.animTimer); this.animTimer = null }
    }
  }
}
</script>

<style scoped>
.cm {
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
  color: #6b4a5a;
  max-width: 480px;
  margin: 0 auto;
}
.cm-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 14px;
}
.cm-title {
  font-size: 22px;
  font-weight: 800;
  color: #e25b96;
  letter-spacing: 1px;
}
.cm-caught {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  max-width: 240px;
  padding: 6px 12px;
  border-radius: 999px;
  background: #fff7fb;
  border: 1px solid #ffddea;
  min-height: 34px;
}
.cm-caught-item {
  font-size: 18px;
  animation: cm-pop 0.35s ease;
}
.cm-caught-empty {
  font-size: 12px;
  color: #c490a8;
}
@keyframes cm-pop {
  0% { transform: scale(0.3) rotate(-20deg); }
  60% { transform: scale(1.25); }
  100% { transform: scale(1); }
}

/* ---------- 机台 ---------- */
.cm-stage {
  position: relative;
  width: 100%;
  max-width: 380px;
  margin: 0 auto;
  padding: 0 14px 14px;
  border-radius: 20px;
  background: linear-gradient(170deg, #ffe9f3, #ffd9ea 60%, #ffcfe3);
  border: 2px solid #ffc3da;
  box-shadow: 0 10px 30px rgba(255, 158, 198, 0.3);
  overflow: hidden;
}
.cm-track {
  position: relative;
  height: 26px;
  margin: 0 -14px;
  background: linear-gradient(180deg, #fff, #fff0f7);
  border-bottom: 2px solid #ffc3da;
  z-index: 2;
}
.cm-claw {
  position: absolute;
  top: 0;
  width: 30px;
}
.cm-claw-arm {
  width: 3px;
  margin: 0 auto;
  background: linear-gradient(180deg, #d98aa6, #ff9ec5);
  border-radius: 2px;
}
.cm-claw-head {
  position: absolute;
  top: 0;
  left: 0;
  width: 30px;
  height: 22px;
  background: linear-gradient(135deg, #ff8fc7, #e05597);
  border-radius: 8px 8px 4px 4px;
  box-shadow: 0 2px 6px rgba(224, 85, 151, 0.4);
}
.cm-pincer {
  position: absolute;
  bottom: -8px;
  width: 9px;
  height: 14px;
  background: linear-gradient(180deg, #e05597, #bd3676);
  border-radius: 0 0 6px 6px;
  transition: transform 0.18s ease;
}
.cm-pincer-l { left: 2px; transform-origin: top center; }
.cm-pincer-r { right: 2px; transform-origin: top center; }
.cm-claw-head.grabbing .cm-pincer-l { transform: rotate(22deg); }
.cm-claw-head.grabbing .cm-pincer-r { transform: rotate(-22deg); }
.cm-held {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 22px;
  z-index: 1;
  filter: drop-shadow(0 3px 5px rgba(0, 0, 0, 0.18));
  animation: cm-held 0.2s ease;
}
@keyframes cm-held {
  0% { transform: translateX(-50%) scale(0.4); }
  100% { transform: translateX(-50%) scale(1); }
}

.cm-zone {
  position: relative;
  height: 116px;
  margin: 0 -14px;
  background:
    radial-gradient(300px 90px at 50% 0%, rgba(255, 255, 255, 0.55), transparent 70%),
    linear-gradient(180deg, #ffd6e8, #ffc3da);
  z-index: 1;
}
.cm-doll {
  position: absolute;
  font-size: 26px;
  transform: translateX(-50%);
  filter: drop-shadow(0 3px 5px rgba(160, 70, 120, 0.3));
  transition: opacity 0.25s ease;
  user-select: none;
}
.cm-chute {
  position: relative;
  margin: 10px -14px 0;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #ff9ec5, #ff6fa5);
  border-radius: 12px;
  color: #fff;
}
.cm-chute-label {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 2px;
}
.cm-state-tip {
  position: absolute;
  top: 40px;
  left: 50%;
  transform: translateX(-50%);
  padding: 4px 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid #ffd3e4;
  font-size: 12px;
  color: #e25b96;
  font-weight: 600;
  white-space: nowrap;
  z-index: 3;
  pointer-events: none;
}

/* ---------- 控制区 ---------- */
.cm-controls {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 16px;
}
.cm-btn {
  border: 2px solid #ffd3e4;
  border-radius: 14px;
  padding: 10px 22px;
  background: #fff;
  color: #b06a8a;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}
.cm-btn:hover:not(:disabled) {
  border-color: #ff6fa5;
  transform: translateY(-2px);
}
.cm-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.cm-btn-drop {
  background: linear-gradient(135deg, #ff8fc7, #ff6fa5);
  border-color: #ff6fa5;
  color: #fff;
  box-shadow: 0 5px 14px rgba(255, 111, 165, 0.4);
}
.cm-tip {
  text-align: center;
  font-size: 12px;
  color: #c490a8;
  margin-top: 10px;
}
</style>
